/* Polsk katalog for locale-pension-invoice-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'otp.sourceRequired': 'Dokument ze skrzynki odbiorczej lub istniejący dowód księgowy',
  'otp.positivePremium': 'Składka emerytalna większa niż 0 kr',
  'otp.completeBeforePreview': 'Uzupełnij lub wybierz przed wyświetleniem propozycji dekretacji:',
  'otp.unlinked': 'Rezerwy płacowe bez powiązania z fakturą',
  'otp.alreadyPosted': 'Już zaksięgowany koszt i płatność',
  'otp.noAccruals': 'Brak dostępnych rezerw płacowych. Już opłacone rezerwy trzeba skorygować, zanim będzie można powiązać je z fakturą.',
  'otp.inboxNotice': 'To wygląda na fakturę emerytalną (OTP). Zarejestruj ją przez Emerytura/OTP, aby rozliczyć ją z rezerwami płacowymi i poprawnie obsłużyć składkę pracodawcy.',
  'otp.open': 'Otwórz w Emerytura/OTP',
  'otp.dismiss': 'To nie dotyczy OTP',
  'otp.invoices': 'Faktury emerytalne i rozliczenie',
  'otp.register': 'Zarejestruj fakturę emerytalną',
  'otp.flow': 'Najpierw powiąż fakturę z rezerwami płacowymi. Płatność rejestruje się na fakturze jeden raz. Składka pracodawcy podąża za faktycznym miesiącem płatności.',
  'otp.invoice': 'Faktura',
  'otp.actual': 'Rzeczywisty koszt',
  'otp.accrued': 'Rozliczona rezerwa',
  'otp.paid': 'Zapłacono',
  'otp.remaining': 'Pozostało',
  'otp.aga': 'AGA przetworzona',
  'otp.reported': 'Raportowanie zarejestrowane',
  'otp.notReported': 'Raportowanie niezarejestrowane',
  'otp.reportingReview': 'Trzeba przejrzeć A-melding',
  'otp.reportingWarning': 'Dla miesiąca płatności zarejestrowano już A-melding. Możesz zarejestrować płatność, ale musisz przejrzeć i w razie potrzeby skorygować A-melding z zaktualizowaną podstawą emerytalną i AGA. Wcześniejsze złożenie nie zmienia się automatycznie.',
  'otp.annulled': 'Powiązanie anulowane',
  'otp.details': 'Zobacz szczegóły',
  'otp.document': 'Dokument ze skrzynki odbiorczej',
  'otp.existing': 'Powiąż z istniejącym dowodem księgowym',
  'otp.supplierName': 'Dostawca',
  'otp.invoiceNumber': 'Numer faktury',
  'otp.invoiceDate': 'Data faktury',
  'otp.dueDate': 'Termin płatności',
  'otp.date': 'Data rozliczenia',
  'otp.premium': 'Składka emerytalna pracodawcy',
  'otp.administration': 'Administracja planu emerytalnego (bez VAT)',
  'otp.components': 'Potwierdź, że kwoty dotyczą składki pracodawcy i ewentualnej administracji planu emerytalnego, bez VAT. Udział pracownika, opłaty za przeniesienie i inne składniki trzeba wyjaśnić osobno przed użyciem tego procesu.',
  'otp.selectAccruals': 'Wybierz rezerwy płacowe, których dotyczy faktura',
  'otp.preview': 'Pokaż propozycję dekretacji',
  'otp.difference': 'Różnica względem rezerwy',
  'otp.existingPreview': 'Istniejący zakup i płatność zostają zachowane. Poniżej pokazano tylko rozliczenie i ewentualną reklasyfikację. Kwota dodatnia to Wn, ujemna to Ma.',
  'otp.newPreview': 'Faktura jest księgowana na 5950 w korespondencji ze zobowiązaniami wobec dostawców 2400. Poniżej pokazano rozliczenie wcześniejszych rezerw. Kwota dodatnia to Wn, ujemna to Ma. Płatność rejestruje się osobno.',
  'otp.confirm': 'Potwierdź fakturę i rozliczenie',
  'otp.saved': 'Rejestracja OTP została zapisana.',
  'otp.purchasePosting': 'Zobacz dowód zakupu',
  'otp.allocationPosting': 'Zobacz rozliczenie',
  'otp.paymentDocumented': 'Rejestruj tylko udokumentowaną płatność, która nie została jeszcze zaksięgowana. Nie wykonuje to żadnego przelewu bankowego.',
  'otp.reversePayment': 'Anuluj płatność',
  'otp.annulLink': 'Anuluj rozliczenie',
  'otp.annulExplanation': 'Rozliczenie i powiązana AGA zostają stornowane. Faktura zakupu i płatność pozostają. Następnie ponownie powiąż fakturę z właściwymi rezerwami. Nie zmienia to żadnego przelewu bankowego.',
});
